RivalIQ.module('graph.utils', function (utils, App, Backbone, Marionette, $, _) {
    'use strict';

    /**
     * Creates a tooltip from a configuration on the given element.
     * @param el
     * @param tooltip
     */
    utils.createTooltip = function (nodes, tooltip, indexOffset, options) {

        if (!tooltip) {

            return;
        }

        indexOffset = indexOffset || 0;

        nodes
            .on('mouseenter', function (d, j, i) {

                const $el = $(this);

                try {
                    // Sometimes these events will fire during an animation transition. Unfortunately, the event for the start of that animation can
                    // be delayed, so I can't easily detect when we're in an animation. to silence errors, just catch the exception here to ignore it.
                    $el.popover({
                        title: tooltip.title ? tooltip.title(d, j, i) : false,
                        content: tooltip.content(d, j, indexOffset + i, options),
                        trigger: 'manual',
                        container: 'body',
                        placement: 'auto right',
                        html: true
                    });
                    $el.popover('show');
                } catch (ex) {
                    if (ex.name !== 'ticks_not_defined') {
                        throw ex;
                    }
                }
            })
            .on('mouseleave', function () {
                const $el = $(this);
                // NOTE Destroy instead of hide to prevent accidental caching
                // when d3 nodes are reused
                $el.popover('destroy');
            });
    };

    utils.createTrendsTooltip = function (view, nodes, tooltip, indexOffset, options) {
        if (!tooltip) {
            return;
        }

        indexOffset = indexOffset || 0;

        let showing = false;
        let showingIdx = -1;

        nodes
            .on('mouseenter', function (data, index, i) {
                const $el = $(this);

                if (_.get(data, [0, 'suppressTooltip'])) {
                    return;
                }

                // Sometimes these events will fire during an animation transition. Unfortunately, the event for the start of that animation can
                // be delayed, so I can't easily detect when we're in an animation. to silence errors, just catch the exception here to ignore it.
                try {
                    setTimeout(function () {
                        if (index !== showingIdx) {
                            if ($('.popover:hover').length) {
                                // This means we're showing a popover and the user is hovering over it; take no action.
                                return;
                            }
                            $('.popover').popover('destroy');
                        }

                        $el.popover({
                            title: tooltip.title ? tooltip.title(data, index, i) : false,
                            content: tooltip.content(data, index, indexOffset + i, options),
                            trigger: 'manual',
                            container: 'body',
                            placement: 'auto top',
                            html: true
                        });

                        if (!showing || index !== showingIdx) {
                            $el.popover('show');
                        }
                        showing = true;
                        showingIdx = index;

                        $('.x-view-content').one('click', function (event) {
                            const companyId = $(event.currentTarget).data('company-id');
                            let company = null;
                            if (companyId) {
                                company = RivalIQ.state.landscape.getCompanyById(companyId);
                            }

                            // hour, minute, second, millisecond matters
                            // we need to make sure that our time period starts beginning of day (00:00:00.000)
                            // and ends end of day (23:59:59.999), all in UTC
                            view.trigger('analyze-content', company, {
                                mainPeriodStart: moment.utc(data.date).startOf(view.tickSize),
                                mainPeriodEnd: moment.utc(data.date).endOf(view.tickSize)
                            }, data[0].x);

                            $el.popover('destroy');
                            showing = false;
                            showingIdx = -1;

                            return false;
                        });

                        $('.popover').on('mouseleave', function () {
                            // If we're here, they were hovering over the popover then just left. In this case, only hide
                            // the popover if they're not currently hovering over the range band.
                            if (showing && !$el.is(':hover')) {
                                showing = false;
                                showingIdx = -1;
                                $el.popover('destroy');
                                $('.x-view-content').off('click');
                            }
                        });
                    }, 100);

                } catch (ex) {
                    if (ex.name !== 'ticks_not_defined') {
                        throw ex;
                    }
                }
            })
            .on('mouseleave', function (data, index, i) {
                const $el = $(this);

                // on mouseleave, give the user 300ms to get their cursor over to the tooltip. If after 300ms they're not
                // over the tooltip, then we can safely hide it.
                setTimeout(function () {
                    if (showing && showingIdx === index && !$el.is(':hover')) {
                        if (!$('.popover:hover').length) {
                            showing = false;
                            showingIdx = -1;
                            $el.popover('destroy');
                            $('.x-view-content').off('click');
                        }
                    }
                }, 300);
            });
    };

    /**
     * Gets the BBox for an SVG text node.
     * @param text
     * @returns {*}
     */
    utils.getTextBoundingBox = function getTextBBox(text) {

        let clone;

        if (_.isString(text)) {

            clone = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            clone.appendChild(document.createTextNode(text));
        } else {

            // NOTE we need to clone the text node, and deep, because if we were
            // to add the node directly to our temporary SVG document it would be
            // removed along with it (when we call removeChild)
            clone = text.cloneNode(true);
        }

        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('style', 'position: absolute; left: -999em;');
        svg.appendChild(clone);
        document.body.appendChild(svg);
        const bBox = clone.getBBox();
        document.body.removeChild(svg);
        return bBox;
    };

    const Y_DOMAIN_VALUE_PADDING = 0.015;

    function isDiscrete(metric) {
        const type = metric.getType();
        const timeAnalysisMode = metric.getTimeAnalysisMode();
        return (type === RivalIQ.enums.dataType.INTEGER &&
            timeAnalysisMode !== RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE);
    }

    utils.getPaddedYDomain = function (metric, domain, ticks, specifiedYMax) {
        const isDiscreteMetric = isDiscrete(metric);

        let yMin = _.head(domain);
        if (!_.isFinite(yMin)) {
            yMin = 0;
        }

        let paddedYMin;
        if (yMin < 0) {
            paddedYMin = yMin * (1 + Y_DOMAIN_VALUE_PADDING);
        } else {
            paddedYMin = yMin * (1 - Y_DOMAIN_VALUE_PADDING);
        }

        if (isDiscreteMetric) {
            paddedYMin = Math.floor(paddedYMin);
        } else if (!paddedYMin) {
            paddedYMin = 0;
        }

        if (metric.getMetricType() === RivalIQ.enums.metricType.VOLUME && paddedYMin > 0) {
            paddedYMin = 0;
        }

        let paddedYMax;
        if (!_.isUndefined(specifiedYMax)) {
            paddedYMax = specifiedYMax;
        } else {
            let yMax = _.last(domain);
            if (!_.isFinite(yMax)) {
                yMax = 0;
            }

            if (yMax < 0) {
                paddedYMax = yMax * (1 - Y_DOMAIN_VALUE_PADDING);
            } else {
                paddedYMax = yMax * (1 + Y_DOMAIN_VALUE_PADDING);
            }
        }

        if (isDiscreteMetric) {
            paddedYMax = Math.ceil(paddedYMax);
            const range = paddedYMax - paddedYMin;
            if (Math.abs(range) < ticks) {
                paddedYMax = paddedYMin + ticks;
            }
        } else if (paddedYMax === paddedYMin) {
            // NOTE we are looking at a continuous domain and do not have a max,
            // so we want to add one (which should downstream be divided by ticks)
            paddedYMax = paddedYMin + 1;
        }

        return [paddedYMin, paddedYMax];
    };

});
